import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetInTouchRibbonComponent } from './get-in-touch-ribbon/get-in-touch-ribbon.component';
import { RouterModule } from '@angular/router';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { LegalComponent } from './legal/legal.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { SitemapComponent } from './sitemap/sitemap.component';
import { MainCarouselComponent } from './main-carousel/main-carousel.component';
import { SWIPER_CONFIG, SwiperModule, SwiperConfigInterface } from 'ngx-swiper-wrapper';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

@NgModule({
  declarations: [
    GetInTouchRibbonComponent, 
    TermsOfUseComponent, 
    LegalComponent, 
    PrivacyComponent, 
    SitemapComponent, MainCarouselComponent],
  imports: [
    CommonModule,
    RouterModule,
    SwiperModule,
  ],
  exports: [
    GetInTouchRibbonComponent,
    SwiperModule,
    MainCarouselComponent
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ]
})
export class SharedModule { }
